import React, { FC, useRef, useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import TooltipModalWrapper from "../Reusable/TooltipModalWrapper.tsx";
import BrandingModal from "../Modals/BrandingModal.tsx";
import { ButtonAccessability } from "components/Elements/Button/Button.js";

const HomeBrandingElement: FC = () => {
  const [hover, setHover] = useState(false);

  const ref = useRef();

  useOnClickOutside(ref, () => {
    setHover(false);
  });

  return (
    <div className="home-branding-elem" ref={ref}>
      <ButtonAccessability onMouseEnter={() => setHover(true)}>
        <Icon name="branding" blue />
      </ButtonAccessability>
      {hover && (
        <TooltipModalWrapper targetRef={ref.current} pos="right">
          <BrandingModal />
        </TooltipModalWrapper>
      )}
    </div>
  );
};

export default HomeBrandingElement;
